export function ResearchFilter() {
	ResearchFilterInit();
}

var $ = window.jQuery;

function ResearchFilterInit() {

	var filterBtns = $( '.bsd-research-objectives-info__header .bsd-filters input[type="radio"]' );
	var filters = [];
	var items = $( '.bsd-research-objectives-info__body' ).find( '.spirit-card' );

	filterBtns.on( 'click', function () {
		fadeOutItems();
		filterItems();
	} );

	function fadeOutItems() {
		items.addClass( 'f-out' );
	}

	function fadeInItems() {
		items.removeClass( 'f-in f-out' );
	}

	function filterItems() {
		filters = [];

		Array.from( filterBtns ).forEach( button => {

			if( button.checked ) {
				filters.push( button.value );
			}
		} );

		if ( 0 < filters.length ) {
			items.each( function () {
				var cat = $( this ).data( 'cat' ).split( ' ' );
				var match = false;

				for ( var i = 0; i < filters.length; i++ ) {
					if ( -1 < cat.indexOf( filters[i] ) ) {
						match = true;
						break;
					}
				}

				if ( match ? $( this ).addClass( 'f-in' ) : $( this ).removeClass( 'f-in' ) );

			} );
		} else {
			fadeInItems();
		}

	}

}
